import { FILTER_TYPE_TEXT, FILTER_TYPE_MULTISELECT } from "@/store/system/helpers";
import store from "@/store";

export function getBlankCriteria() {
  return {
    emailAddress: null,
    familyName: null,
    firstName: null,
    status: [],
    role: []
  };
}

export function getSearchFilters() {
  return [
    { text: "Email address", value: "emailAddress", type: FILTER_TYPE_TEXT },
    { text: "Family name", value: "familyName", width: 6, type: FILTER_TYPE_TEXT },
    { text: "First name", value: "firstName", width: 6, type: FILTER_TYPE_TEXT },
    {
      text: "Status",
      value: "status",
      type: FILTER_TYPE_MULTISELECT,
      width: 6,
      items: store.state.lookups.data.userStatuses
    },
    { text: "Role", value: "role", type: FILTER_TYPE_MULTISELECT, width: 6, items: store.state.lookups.data.roleCodes }
  ];
}

export function getBlankRecord() {
  return {
    emailAddress: null,
    failedAttempts: null,
    familyName: null,
    firstName: null,
    id: null,
    lastLogonDate: null,
    password: null,
    passwordExpiryDate: null,
    roles: [],
    status: null,
    userId: null,
    userTypeRefCode: null
  };
}

export function getBlankMfaProfileRecord() {
  return {
    prismsUserId: null,
    firstName: null,
    familyName: null,
    emailAddress: null,
    mfaOptedOut: null,
    mfaCanOptOut: null,
    mfaOptedOutReason: null,
    mfaRegistrationNumber: null,
    mfaVerificationMethod: null,
    activeMfaTemporaryBypassValidToDate: null,
    mfaRegistrationStatus: null
  };
}
